import { useEffect, useState } from "react";
import { Icon } from "../../../../../../Elements/Icon";

import * as styles  from "./styles.module.scss";

export const TrackControls = () => {
    const [playing, setPlaying] = useState(false);

    const handlePlay = () => {
        setPlaying((state) => !state);
        window.audioplayer.playPause();
    };

    const handleNext = () => {
        window.audioplayer.next();
    };

    const handlePrevious = () => {
        window.audioplayer.previous();
    };

    const handleBackward = () => {
        window.audioplayer.backward(10);
    };

    const handleForward = () => {
        window.audioplayer.forward(10);
    };

    useEffect(() => {
        setPlaying(window.audioplayer.meta().playing);

        const playListener = () => setPlaying(true);
        const pauseListener = () => setPlaying(false);

        window.audioplayer.addEventListener("play", playListener);
        window.audioplayer.addEventListener("pause", pauseListener);
        window.audioplayer.addEventListener("reset", pauseListener);

        return () => {
            window.audioplayer.removeEventListener("play", playListener);
            window.audioplayer.removeEventListener("pause", pauseListener);
            window.audioplayer.removeEventListener("reset", pauseListener);
        };
    });

    return (
        <div className={styles.controls}>
            <button
                type="button"
                className={styles.button}
                onClick={handleBackward}
            >
                <Icon name="rewind" width="26" height="28" />
            </button>

            <div className={styles.main}>
                <button
                    type="button"
                    className={styles.button}
                    onClick={handlePrevious}
                >
                    <Icon name="previous" width="18" height="18" />
                </button>

                <button
                    type="button"
                    className={styles.play}
                    onClick={handlePlay}
                >
                    <Icon
                        name={playing ? "pause" : "play"}
                        width="20"
                        height="26"
                    />
                </button>

                <button
                    type="button"
                    className={styles.button}
                    onClick={handleNext}
                >
                    <Icon name="next" width="18" height="18" />
                </button>
            </div>

            <button
                type="button"
                className={styles.button}
                onClick={handleForward}
            >
                <Icon name="forward" width="26" height="28" />
            </button>
        </div>
    );
};
